export enum TreasureFiEmails {
  Support = 'support@treasure.tech',
}
